import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { selectorProps } from '../common/form';
import getAllEditors from '../../../services/lwadmin/profile/profile-search-service';

const mapper = ({ id, name }) => ({ label: name, value: id });

export default function AccountManagerControl({ accountManagerId, onSelected }) {
  const [editors, setEditors] = React.useState([]);
  const v = _.find(editors, { value: accountManagerId });

  React.useEffect(() => {
    getAllEditors().then(res => {
      const list = _.get(res, 'data.editors', []);
      setEditors(list.map(mapper));
    });
  }, []);

  const handleOnChange = ({ label, value }) => {
    onSelected({ id: value, name: label });
  };

  return (
    <>
      Account manager
      <Select
        {...selectorProps}
        className="account-manager-select-container"
        value={v}
        onChange={handleOnChange}
        options={editors}
      />
    </>
  );
}

AccountManagerControl.propTypes = {
  accountManagerId: PropTypes.number,
  onSelected: PropTypes.func.isRequired,
};

AccountManagerControl.defaultProps = { accountManagerId: null };
